import React, { useState } from 'react';
import { useTranslation } from '../translations/useTranslation';
import { 
  Box, 
  Flex, 
  Icon, 
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  VStack,
  Divider,
  useMediaQuery,
  useDisclosure
} from '@chakra-ui/react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaHome, FaNewspaper, FaHorse, FaComments, FaUser, FaUserEdit, FaBoxOpen, FaSignOutAlt, FaSignInAlt, FaUserPlus, FaStore } from 'react-icons/fa';
import '../MobileBottomNav.css';

const MobileBottomNav = ({ setStaticModal, toggleShow, setActiveTab }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  const isAuth = localStorage.getItem("authToken") ? true : false;
  
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authemail");
    localStorage.removeItem("authname");
    localStorage.removeItem("authpicture");
    localStorage.removeItem("authphone");
    window.location.href = "/";
  };

  const handleLogin = () => {
    if (toggleShow && setActiveTab) {
      setActiveTab('tab1'); // Set to login tab
      toggleShow();
      onClose();
    } else {
      navigate('/');
      onClose();
    }
  };
  
  const handleSignup = () => {
    if (toggleShow && setActiveTab) {
      setActiveTab('tab2'); // Set to register tab
      toggleShow();
      onClose();
    } else {
      navigate('/');
      onClose();
    }
  };
  
  const isActive = (path) => {
    if (path === '/') return location.pathname === path;
    return location.pathname.startsWith(path);
  };
  
  if (!isMobile) return null;
  
  return (
    <Box className="mobile-bottom-nav">
      <Flex justify="space-around" align="center" h="100%">
        <Link to="/" className={`nav-item ${isActive('/') ? 'active' : ''}`}>
          <VStack spacing={1}>
            <Icon as={FaHome} boxSize={5} />
            <Text fontSize="xs">{t('home') || "Home"}</Text>
          </VStack>
        </Link>
        
        <Link to="/social" className={`nav-item ${isActive('/social') ? 'active' : ''}`}>
          <VStack spacing={1}>
            <Icon as={FaNewspaper} boxSize={5} />
            <Text fontSize="xs">{t('feed') || "Feed"}</Text>
          </VStack>
        </Link>
        
        <Link to="/livestock" className={`nav-item ${isActive('/livestock') ? 'active' : ''}`}>
          <VStack spacing={1}>
            <Icon as={FaHorse} boxSize={5} />
            <Text fontSize="xs">{t('animalTrade') || "Animal Trade"}</Text>
          </VStack>
        </Link>
        
        <Link to={isAuth ? "/chat" : "/"} className={`nav-item ${isActive('/chat') ? 'active' : ''}`}>
          <VStack spacing={1}>
            <Icon as={FaComments} boxSize={5} />
            <Text fontSize="xs">{t('chat') || "Chat"}</Text>
          </VStack>
        </Link>
        
        <Popover
          placement="top-end"
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          closeOnBlur={true}
        >
          <PopoverTrigger>
            <Box className={`nav-item ${isActive('/profile') ? 'active' : ''}`}>
              <VStack spacing={1}>
                <Icon as={FaUser} boxSize={5} />
                <Text fontSize="xs">{t('profile') || "Profile"}</Text>
              </VStack>
            </Box>
          </PopoverTrigger>
          <PopoverContent width="200px" className="profile-popover">
            <PopoverBody p={0}>
              {isAuth ? (
                <VStack align="stretch" spacing={0} divider={<Divider />}>
                  <Link to="/profile" onClick={onClose}>
                    <Flex align="center" p={3} className="profile-menu-item">
                      <Icon as={FaUserEdit} mr={3} />
                      <Text>{t('viewEditProfile') || "View/Edit Profile"}</Text>
                    </Flex>
                  </Link>
                  <Link to="/myads" onClick={onClose}>
                    <Flex align="center" p={3} className="profile-menu-item">
                      <Icon as={FaBoxOpen} mr={3} />
                      <Text>{t('myProducts') || "My Products"}</Text>
                    </Flex>
                  </Link>
                  <Box onClick={() => { handleLogout(); onClose(); }}>
                    <Flex align="center" p={3} className="profile-menu-item">
                      <Icon as={FaSignOutAlt} mr={3} />
                      <Text>{t('logout') || "Logout"}</Text>
                    </Flex>
                  </Box>
                </VStack>
              ) : (
                <VStack align="stretch" spacing={0} divider={<Divider />}>
                  <Box onClick={handleLogin}>
                    <Flex align="center" p={3} className="profile-menu-item">
                      <Icon as={FaSignInAlt} mr={3} />
                      <Text>{t('login') || "Login"}</Text>
                    </Flex>
                  </Box>
                  <Box onClick={handleSignup}>
                    <Flex align="center" p={3} className="profile-menu-item">
                      <Icon as={FaUserPlus} mr={3} />
                      <Text>{t('register') || "Register"}</Text>
                    </Flex>
                  </Box>
                </VStack>
              )}
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Flex>
    </Box>
  );
};

export default MobileBottomNav;